// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CartProvider } from './components/CartContext';
import Tiendav3 from './components/Tiendav3';
import Carrito from './components/carrito';
import ProductoPage from './components/Productos';
import CategoriaPage from './components/CategoriaPage';
import './App.css';
import Checkout from './components/checkout';

function App() {
  return (
    <CartProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Tiendav3 />} />
          <Route path="/tienda" element={<Tiendav3 />} />
          <Route path="/carrito" element={<Carrito />} />
          <Route path="/producto/:id" element={<ProductoPage />} />
          <Route path="/categoria/:id" element={<CategoriaPage />} />
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </div>
    </CartProvider>
  );
}

export default App;